export default __webpack_public_path__ + "static/media/bg_3.634c15bf.png";